import ajax from '@/utils/ajax';

export const head = '/applets';

// C端通过考季预览考研日程详情
export const reqExamSeasonPreview= (code,type) => ajax(`${head}/v1/pg-exam-schedule/exam-season/preview/${type}/${code}`);
// C端通过考季和学科预览考研备考规划详情
export const reqExamPlanPreview= (examSeasonCode,disciplineId,type) => ajax(`${head}/v1/pg-exam-plan/preview/${type}/${examSeasonCode}/${disciplineId}`);

// C端通过考季获取考研日程主表详情
export const reqExamSchedule = (code) => ajax(`${head}/v1/pg-exam-schedule/exam-season/${code}`);

// C端通过考季和学科获取考研备考规划详情
export const reqExamPlan = (examSeasonCode,disciplineId) => ajax(`${head}/v1/pg-exam-plan/${examSeasonCode}/${disciplineId}`);

// C端通过考季获取考研备考规划学科
export const reqExamSubject = (examSeasonCode) => ajax(`${head}/v1/pg-exam-plan/discipline/${examSeasonCode}`);
// C端获取考研规划学科
export const reqExamSeason = () => ajax(`${head}/v1/pg-exam-schedule/exam-season`);
